<template>
  <div>
    <div class="hbb_selectBox" v-if="partItem != null">
      <MySwiper :list="listArr"></MySwiper>
      <div class="hbb_partItemTitle">
        <span class="sdw_partitem_title">{{partItem.brandName}} {{partItem.categoryName}} {{partItem.displayPartsNo}}</span>
        <span class="sdw_partitem_label sdw_partitem_series" v-if="partItem.series.length > 0">{{partItem.series}}</span>
        <span class="sdw_partitem_label sdw_partitem_place" v-if="partItem.place.length > 0">{{partItem.place}}</span>
        <span class="sdw_partitem_label sdw_partitem_status" v-if="partItem.status.length > 0">{{partItem.status}}</span>
      </div>
      <div class="sdw_partItemDesc">
        <span class="sdw_partitem_desc" v-if="partItem.description.length > 0">{{partItem.description}}</span>
        <span class="sdw_partitem_price" v-if="partItem.guidePrice_text.length > 0">参考价: <b>{{partItem.guidePrice_text}}</b></span>
      </div>
      
    </div>
    <div class="hbb_otherCode" v-if="partItem.otherCodesStr">
        <p><span>其他编码：</span><span class="two">{{partItem.otherCodesStr}}</span></p>
      </div>
    <div class="sdw_partItemProperty">
      <table border="0" cellpadding="0" cellspacing="0" style="border-right:1px solid #ddd;width:100%">
        <tr class="con" v-for="(item,index) in properties" :key="index">
          <td v-for="(it,inde) in item" :key="inde">
            <span class="one">{{it.name}}</span>
            <span>{{it.value}}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import MySwiper from "@components/MySwiper/Index";
export default {
  components: {
    MySwiper
  },
  props: {
    jYAutoByVin: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      partItem: null, //商品详情
      listArr: [], // 幻灯片集合
      properties: [] // 商品的规格
    };
  },
  methods: {
    ...mapActions({
      GetPartItemDetail: "SearchResultModule/GetPartItemDetail"
    }),
    startup(partItemId) {
      // 启动组件
      let _this = this;
      this.GetPartItemDetail({
        partItemId: partItemId
      }).then(res => {
        _this.partItem = res;
        _this.listArr = res.images;

        var oneTr = [];
        for (var i = 0; i < res.properties.length; i++) {
          if (i % 2 == 0) {
            oneTr.push(res.properties[i]);
          } else {
            oneTr.push(res.properties[i]);
            _this.properties.push(oneTr);
            oneTr = [];
          }
        }
        if (oneTr.length > 0) {
          properties.push({
            ParamName: "",
            ParamValue: ""
          });
          _this.properties.push(oneTr);
        }
      });
    }
  }
};
</script>

<style>
.hbb_selectBox {
  width: 100%;
  padding: 10px 0;

}
.hbb_partItem p {
  width: 100%;
  padding: 10px 0;
}
.hbb_partItem p span {
  float: left;
  width: 28%;
}
.hbb_partItemTitle {
  display: flex;
  width: 100%;
  margin-top: 12px;
  justify-content: flex-start;
  align-items: center;
}
.hbb_partItemTitle .sdw_partitem_title {
  font-size: 18px;
  color: #181818;
}
.hbb_partItemTitle .sdw_partitem_label {
  width: auto;
  min-width: 20px;
  padding: 0 6px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  margin-left: 6px;
  clear: none;
}
.hbb_partItemTitle .sdw_partitem_series {
  background: #006ad7;
}
.hbb_partItemTitle .sdw_partitem_place {
  background: #e74c3c;
}
.hbb_partItemTitle .sdw_partitem_status {
  background: #bfbfbf;
}

.sdw_partItemDesc {
  width: 100%;
  height: auto;
  padding: 6px 0 0;
  display: inherit;
  justify-content: space-between;
  align-items: flex-start;
}
.sdw_partItemDesc .sdw_partitem_desc {
  color: #f4ad38;
  line-height: 24px;
  float: left;
  clear: none;
}
.sdw_partItemDesc .sdw_partitem_price {
  width: 21%;
  font-size: 12px;
  line-height: 24px;
  text-align: right;
  color: #e74c3c;
  flex-shrink: 0;
  float: right;
  clear: none;
}
.sdw_partItemDesc .sdw_partitem_price b {
  font-size: 16px;
}
.sdw_partItemProperty {
  display: flex;
  width: 100%;
  height: auto;
  max-height: 300px;
  overflow: hidden;
  overflow-y: auto;
  /* margin-top: 20px; */
  border-top: 1px solid #ddd;
  flex-direction: column;
}
.sdw_partItemProperty .con {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #ddd;
  border-left: 1px solid #ddd;
  align-items: center;
  background: #f6f6f6;
  align-items: stretch;
}
.sdw_partItemProperty .con td {
  display: flex;
  width: 50%;
  align-items: center;
  background: #f6f6f6;
  align-items: stretch;
}
.sdw_partItemProperty td span {
  display: flex;
  font-size: 12px;
  padding: 10px 6px;
  background: #FFF;
  justify-content: flex-start;
  align-items: center;
}
.sdw_partItemProperty td span.one {
  background: #f6f6f6;
  width: 120px;
  font-size: 14px;
  line-height: 20px;
  color: #8e8e8e;
  font-weight: 700;
  background: #f6f6f6;
}
.sdw_partItemProperty td span {
  width: calc(100% - 120px);
  font-size: 14px;
  line-height: 20px;
  color: #282828;
}
.hbb_otherCode{
  display: flex;
  width: 100%;
  margin: 10px 0;
}
.hbb_otherCode span{
  float: left;
  width: 70px;
}
.hbb_otherCode span.two{
  float: left;
  width: calc(100% - 70px);
  text-align:justify;

}
</style>